import { render, staticRenderFns } from "./PlayerOfferPersonal.vue?vue&type=template&id=28892a0b&"
import script from "./PlayerOfferPersonal.vue?vue&type=script&lang=js&"
export * from "./PlayerOfferPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports